module.exports = __webpack_public_path__ + "static/img/detail_hummer_02.253a25a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/hummer-press-pass-video-campaign/detail_hummer_02.jpg
// module id = 249
// module chunks = 2